import { PropsWithChildren, useState } from 'react';
import { Box, Flex } from 'reflexbox';
import Measure, { ContentRect } from 'react-measure';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useDebouncedCallback } from 'use-debounce';

const Container = styled(Box)``;

const Clip = styled(Box)<{ mask: boolean }>`
	overflow: hidden;
	${(props) => (props.mask ? `mask: linear-gradient(black, transparent)` : undefined)};
`;

const ReadMore = styled.a`
	cursor: pointer;
	color: ${(props) => props.theme.colors.slateBlue};
	text-decoration: underline;

	&:hover {
		color: ${(props) => props.theme.colors.primary};

		&:active {
			color: ${(props) => props.theme.colors.primaryDark};
		}
	}
`;

export function Snippet(props: PropsWithChildren<{ maxHeight: number }>) {
	const [contentRect, setContentRect] = useState<ContentRect | null>(null);
	const { t } = useTranslation();

	const [collapsed, setCollapsed] = useState(true);
	const showMore = !collapsed || (contentRect?.bounds?.height ?? props.maxHeight) < props.maxHeight;

	const updateContentRect = useDebouncedCallback(setContentRect, 1);

	return (
		<Container>
			<Clip mask={!showMore} maxHeight={!showMore ? props.maxHeight : undefined}>
				<Measure bounds onResize={(rect) => updateContentRect(rect)}>
					{({ measureRef }) => <Box ref={measureRef}>{props.children}</Box>}
				</Measure>
			</Clip>
			{!showMore && (
				<Flex justifyContent="center">
					<ReadMore onClick={() => setCollapsed(false)}>{t('common.learnMore')}</ReadMore>
				</Flex>
			)}
		</Container>
	);
}
